module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cards/image-over-card/image-over-card.component.scss
// module id = ./src/app/shared/components/cards/image-over-card/image-over-card.component.scss
// module chunks = main